<div class="w-full  text-slate-600 dark:text-slate-300 p-0" [class]="shortShow?'mb-0':'mb-6 rounded-[7px] border  bg-lightCardBG dark:bg-darkCardBG border-lightMode-300 dark:border-darkMode-700 hover:shadow-site hover:shadow-lightMode-400 dark:hover:shadow-darkMode-700'">
    <div *ngIf="horizontalChart.is_show_calculated_type" class="w-full px-2 my-4 pb-0">  
        <button *ngIf="isBackButton()" [routerLink]="getBackButtonUrl()" (click)="setStatusFormBackToForm()" (click)="scrollToTop()" class="flex items-center text-[#1d1d88] dark:text-slate-300 justify-center mb-3 text-sm bg-lightPrimary border border-lightPrimary mx-2 bg-opacity-20 rounded-md py-2 px-3 hover:bg-opacity-50" >
            <i class="fas fa-share ml-2"></i>
            <span>بازگشت به فرم ارزیابی</span>
        </button>                       
        <h2 *ngIf="!shortShow" class="text-center block text-[1.1rem] px-2 w-full font-normal text-lightMode-600 dark:text-darkMode-300">
            <span>{{user.name}}</span>  عزیز، تیپ شما
            <span class="text-lightMode-900 dark:text-white text-[1.5rem] inline-block font-tip direction-end">
                {{getCharType()}}
            </span> است.
        </h2>
        
        <div *ngIf="shortShow && exam" class="flex flex-col p-2 mx-2 items-start justify-between">
            <div class="flex items-start text-sm lg:text-xs justify-between w-full">
                <p class="mb-2">
                    <span class="text-lightMode-900 dark:text-white text-[1rem] font-tip">{{exam.name}}</span>
                </p>
                <p class="mb-2">
                    <span class="hidden lg:inline">تیپ : </span>
                    <span class="text-lightMode-900 dark:text-white text-[1.1rem] inline-block font-tip direction-end">
                        {{getCharType()}}
                    </span> 
                </p>
            </div>
            <div class="flex items-start justify-between w-full">
                <p class="mb-2 text-[0.8rem] text-lightMode-500 dark:text-darkMode-400">
                    <span class="text-lightMode-700 dark:text-darkMode-200">{{returnLastTakeExamDay(exam.given_at)|convertToPersian}}</span>
                    شرکت کرده است
                </p>
                <p class=" text-[0.8rem] text-lightMode-500 dark:text-darkMode-400">
                    <i class="fas fa-clock ml-1"></i>
                    <span>{{getTimePerMinutes(exam?.time.toString())|convertToPersian}}</span>
                </p>
            </div>
        </div>
    </div>
    
    
    <div class="w-full mb-3 flex flex-col items-center justify-center " [class]="shortShow ? 'p-2':'p-1 pt-3'">
        <div class="flex flex-col justify-center items-center w-full p-0 m-0 min-h-auto">
            <div *ngFor="let chart of chartList" [class]="shortShow?'mb-[0.9rem]':'pb-10 mb-2 pt-5  border-b dark:border-darkMode-700'" class="w-[95%] flex items-center justify-center flex-col ">
                <strong *ngIf="!shortShow" [class]="shortShow && chart.left_side_text=='' && chart.right_side_text==''?'py-3':chart.left_side_text=='' && chart.right_side_text=='' && !shortShow?'pb-3':''" class="block text-center w-full text-lightMode-900 dark:text-darkMode-100 text-lg">{{chart.charType.type_explain}}</strong>
                <strong *ngIf="shortShow && chart.left_side_text=='' && chart.right_side_text==''" [class]="shortShow && chart.left_side_text=='' && chart.right_side_text==''?'pb-3':''" class="block text-right px-3 w-full text-lightMode-900 dark:text-darkMode-100 text-lg">{{chart.charType.type_explain}}</strong>
                <span [class]="shortShow?'hidden':'pb-3'" class="decision_tip text-center text-lightMode-600 dark:text-darkMode-300 w-full block font-normal ">
                    {{chart.charType.type_description}}
                </span>
                <div class="flex w-full">
                    <div *ngIf="chart.left_side_text!='' && chart.right_side_text!=''" class=" percent-text font-normal" [class]="shortShow ? 'text-right w-[50px]' : 'text-center w-1/6'">
                        <p *ngIf="!shortShow">
                            %{{chart.score.toString() | convertToPersian}}
                            <br> {{chart.right_side_text}}
                        </p>
                        <span class="font-extrabold" *ngIf="shortShow">
                            %{{chart.score.toString() | convertToPersian}}
                        </span>
                    </div>
                    <div [class]="chart.left_side_text=='' && chart.right_side_text=='' ? 'w-[95%]' : 'w-[calc(100%-100px)]'" class="p-0 mx-auto flex items-center">
                        <div class="w-full bg-lightMode-300 dark:bg-darkMode-600 rounded-full overflow-hidden" [class]="chart.is_fliped ? 'direction-start' : 'direction-end'">
                            <div class="percent-parent bg-lightMode-300 dark:bg-darkMode-600 w-full mx-auto"> 
                                <div class="relative text-center precent progress text-white transition-all duration-[1500ms] ease-in-out" [style]="{ 'background-color':chart.color, 'width':viewInited?setWidth(chart)+'%':'0'}" >
                                    <span *ngIf="chart.left_side_text=='' && chart.right_side_text=='' && !countCompleted" [countUp]="+chart.score" [options]="options" class="count font-normal">{{chart.score}}</span>
                                    <span *ngIf="chart.left_side_text=='' && chart.right_side_text=='' && countCompleted" class="count font-normal">%{{chart.score.toString()|convertToPersian}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="chart.left_side_text!='' && chart.right_side_text!=''" class="percent-text font-normal" [class]="shortShow ? 'text-left w-[50px]' : 'text-center w-1/6'">
                        <p *ngIf="!shortShow">
                            %{{(100 - chart.score).toString() | convertToPersian}}
                            <br> {{chart.left_side_text}}
                        </p>
                        <span class="font-extrabold" *ngIf="shortShow">
                            %{{(100 - chart.score).toString() | convertToPersian}}
                        </span>
                    </div>
                </div>
                <div *ngIf="shortShow" class="w-full flex text-[0.9rem] items-start justify-between mt-1">
                    <p class="text-right">{{chart.right_side_text}}</p>
                    <p class="text-left">{{chart.left_side_text}}</p>
                </div>
            </div>
        </div>
    </div>
</div>